<template>
  <div class="nameplate-type" style="margin-bottom: 24px;">
    <div v-for="(Product,index) in value.hangingDolls" class="nameplate-type__item">
      <input
          :id="'nameplate-type__input--' + Product.id"
          class="nameplate-type__input"
          type="radio"
          name="hangingDoll"
          v-model="value.hangingDoll"
          :value="'hanging_doll_' + Product.id">
      <label class="nameplate-type__label" :for="'nameplate-type__input--' + Product.id">
        <img class="nameplate-type__img" :src="Product.thumbnail" alt="">
        <div class="nameplate-type__title">{{ Product.name }}</div>
        <div class="nameplate-type__check-icon"></div>
      </label>
    </div>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  props: [
    'value',
  ],
  data() {
    return {
      state: false,
    }
  },
}
</script>



<style lang="scss">
.nameplate-type {
  $e: &;
  display: flex;
    flex-wrap: wrap;
  transition: $transition;
  width: calc(100% + 8px);
  margin-left: -4px;

  &__item {
    display: block;
    width: calc(100% / 3 - 8px);
    margin: 4px;
  }
  &__input {
    display: none;
    &:disabled {
      & + #{$e}__label {
        &:hover {
          box-shadow: none;
          border-color: #ece7e7;
        }
      }
    }
    & + #{$e}__label {
    }
    &:checked {
      & + #{$e}__label {
        box-shadow: none;
        border-color: #ed8e9f;
        #{$e}__check-icon {
          opacity: 1;
        }
      }
    }
  }
  &__label {
    display: flex;
    flex-direction: column;
    transition: $transition;
    overflow: hidden;
    position: relative;
    border-radius: 5px;
    border: 3px solid #ece7e7;
    background-color: #fff;
    height: 100%;
    padding: 16px;
    &:hover {
      box-shadow: 0 8px 17px 2px rgba(#000, 0.07), 0 3px 14px 2px rgba(#000, 0.06), 0 0 5px -3px rgba(#000, 0.1);
      border-color: transparent;
    }
  }
  &__img {
    display: block;
    width: 100%;
  }
  &__title {
    font-family: $serif;
    font-size: 15px;
    text-align: center;
    padding-top: 12px;
    margin-top: auto;
  }
  &__sub-title {
    font-size: 11px;
    text-align: center;
    margin-top: 2px;
  }
  &__check-icon {
    opacity: 0;
    transition: $transition;
    position: absolute;
    top: -16px;
    right: -16px;
    background-color: #ed8e9f;
    transform: rotate(45deg);
    width: 32px;
    height: 32px;
    &::before,
    &::after {
      content: "";
      position: absolute;
      background-color: #fff;
      height: 2px;
    }
    &::before {
      top: 25px;
      left: 13px;
      width: 4px;
    }
    &::after {
      top: 23px;
      left: 14px;
      transform: rotate(90deg);
      width: 6px;
    }
  }
}

.app-gogatsu {
    .nameplate-type {
        &__input {
            &:checked {
                & + .nameplate-type__label {
                    box-shadow: none;
                    border-color: $gogatsu-accent-color;
                }
            }
        }
        &__check-icon {
            background-color: $gogatsu-accent-color;
            &::before,
            &::after {
                background-color: #fff;
            }
        }
    }
}
</style>
